import { useCardDetails } from "@/common/hooks/queries/useCardDetails";
import useDebounce from "@/common/hooks/useDebounce";
import { ProductData } from "@/common/types/product.type";
import { useEffect, useState } from "react";
import { useCardCurrentLimits } from "./useCardCurrentLimits";
import { useCardApplicableProducts } from "@/features/consumption/hooks/useCardApplicableProducts";
import { AxiosError } from "axios";

export const useCardCurrentLimitsForm = () => {
  const [errors, setErrors] = useState<string[]>();

  const [cardIdentifier, setCardIdentifier] = useDebounce('');
  const [product, setProduct] = useState<ProductData>();

  const {
    data: cardDetails,
    isPending: cardDetailsIsPending,
    isError: cardDetailsIsError,
  } = useCardDetails(cardIdentifier);

  const {
    data: cardCurrentLimits,
    isPending: cardCurrentLimitsIsPending,
    isError: cardCurrentLimitsIsError,
    error: cardCurrentLimitsError,
  } = useCardCurrentLimits(cardIdentifier, product?.id);

  const {
    data: products,
  } = useCardApplicableProducts<ProductData[]>({
    filters: {
      cardId: cardDetails?.id
    }
  });

  useEffect(() => {
    if (cardCurrentLimitsError) {
      const errors = (cardCurrentLimitsError as AxiosError<{ errors?: { base?: string[] } }>)?.response?.data?.errors?.base;

      if (errors) {
        setErrors(errors);
      }
    } else {
      setErrors(undefined);
    }
  }, [cardCurrentLimitsIsError]);

  return {
    errors,
    setErrors,
    cardIdentifier,
    setCardIdentifier,
    product,
    setProduct,
    cardDetails,
    cardDetailsIsPending,
    cardDetailsIsError,
    cardCurrentLimits,
    cardCurrentLimitsIsPending,
    cardCurrentLimitsIsError,
    cardCurrentLimitsError,
    products,
  }
}
